import React, { useState, useLayoutEffect } from 'react';
import { getUserColor, getShortLetters } from '../../utils/function';

export const UserProfile = () => {
  let [userDetailData, setUserDetails] = useState(null);
  const [toggle, setToggle] = useState(false);
  let getDataLocalStorage = JSON.parse(localStorage.getItem('userDetails'));
  //   let shortName = user.name
  //     .split(' ')
  //     .slice(0, 2)
  //     .map((word) => word[0])
  //     .join('');

  //   console.log('shortName', shortName);
  useLayoutEffect(() => {
    setUserDetails(getDataLocalStorage);
  }, []);

  return (
    <div className="userProfile">
      <div className="iconUser">
        <div
          onClick={() => setToggle(!toggle)}
          className={`btn btn-radius color${
            userDetailData ? getUserColor(userDetailData.name) : ''
          }`}
          // onClick={(e) => {
          //   e.preventDefault();
          //   // Toggle the dropdown manually if not using Bootstrap's JavaScript
          //   const dropdownMenu = document.querySelector('.profileUserCard');
          //   dropdownMenu.classList.toggle('show');
          // }}
        >
          <p className="mb-0">
            {userDetailData && (
              <span
                className={`member-avatar color${getUserColor(
                  userDetailData.name
                )}`}
                title={userDetailData.name}
              >
                {getShortLetters(userDetailData.name)}
              </span>
            )}
          </p>
        </div>
        {toggle ? (
          <div
            className="dropdown-menu profile-card profileUserCard"
            x-placement="bottom-start"
            style={{ top: '102%' }} // Control visibility with JS or CSS
          >
            <div className="pchead">
              <div className="pc-name">
                <div className="short-name">
                  {userDetailData && (
                    <span
                      className={`member-avatar color${getUserColor(
                        userDetailData.name
                      )}`}
                      title={userDetailData.name}
                    >
                      {getShortLetters(userDetailData.name)}
                    </span>
                  )}
                </div>
                <div className="short-detail">
                  <h3>{userDetailData && userDetailData.name}</h3>
                  <h4>{userDetailData && userDetailData.email}</h4>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
